import { useLayoutEffect, useRef } from 'react';

/**
 * 返回始终指向最新值的 ref，供「依赖为 [] 的 effect / 原生事件」中读取，避免陈旧闭包。
 * 用 useLayoutEffect 在绘制前同步，比 useEffect 少一帧滞后。
 */
export function useLatest<T>(value: T) {
    const ref = useRef(value);
    useLayoutEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
